import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrowserCloseService {
  
  constructor() {
    window.addEventListener('beforeunload', () => this.cleanup());
  }

  cleanup() {
    //Trigger Logout API to clear user session
    this.logoutUser();
  }

  logoutUser() {
    const token = sessionStorage.getItem('apigee-jwt');
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    fetch(environment.logoutUrl, {
      method: 'POST',
      headers,
      keepalive: true
    });
  }
}
